<div>This will be the admin UI.</div>
<div class="navigation-items">
    <a [routerLink]="['.', 'users'] | linkFix">Users</a>
</div>
